export const WHATSAPP_NUMBER = '97313619991';

export const getWhatsAppProductUrl = (productName, productId, language = 'en', productPageUrl = '') => {
  const isArabic = language.toLowerCase().startsWith('ar');
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://www.itronixbh.com';
  const productUrl = productPageUrl || (productId ? new URL(`/shop/${encodeURIComponent(productId)}`, origin).href : '');
  const message = productUrl
    ? [
      isArabic
        ? 'مرحباً، وجدت هذا المنتج على موقع آيترونكس وأود الاستفسار عنه:'
        : 'Hi, I found this product on the Itronix website and would like to enquire about it:',
      productName,
      isArabic ? 'رابط المنتج:' : 'Product page:',
      productUrl,
      '',
      isArabic
        ? 'هل يمكنكم تأكيد السعر والتوفر وما إذا كان مناسباً لسيارتي؟'
        : 'Could you please confirm the price, availability, and whether it fits my car?',
    ].filter(Boolean).join('\n')
    : isArabic
      ? `مرحباً، أتواصل معكم من موقع آيترونكس. أود الاستفسار عن ${productName || 'أحد المنتجات'}.`
      : `Hi, I am contacting you from the Itronix website. I would like to ask about ${productName || 'a product'}.`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

export const getWhatsAppShareUrl = ({ productName, productUrl, language = 'en' } = {}) => {
  const isArabic = language.toLowerCase().startsWith('ar');
  const introduction = language.toLowerCase().startsWith('ar')
    ? 'شاهد هذا المنتج من آيترونكس للإلكترونيات'
    : 'Check this product from Itronix Electronics';
  const message = productUrl
    ? [
      `${introduction}${productName ? `: ${productName}` : ''}`,
      isArabic ? 'رابط المنتج:' : 'Product page:',
      productUrl,
    ].filter(Boolean).join('\n')
    : `${introduction}.`;

  return `https://wa.me/?text=${encodeURIComponent(message)}`;
};
